export default {"src":"/_next/static/media/purchasing.30b351bc.svg","height":215,"width":214,"blurWidth":0,"blurHeight":0};